import dayjs from 'dayjs'
// 引入时长插件
import duration from 'dayjs/plugin/duration'
// 引入时区插件
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
// 使用插件
dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Shanghai')

/**
 * 获取固定时区的本地时间
 * @returns {Object} dayjs对象
 */
export function getDayjsLocalTime() {
  return dayjs().tz('Asia/Shanghai')
}

/**
 * 主要功能参考dayjs的文档
 * 进行时间转化时，不直接使用dayjs(time)，改为使用dayjs.tz(time) --- (确保固定时区）
 * 当需要获取本地时间时，使用getDayjsLocalTime()，而不是dayjs()
 */
export default dayjs
